import { getAll } from '@/api/facture/index';
import * as allTypes from '@/store/mutation-type';
import formatListeFactures from '@/services/facture/formatListeFactures';
import genererCritereRecherche from '@/services/facture/genererCritereRechercheFacture';
import * as types from '@/store/modules/facture-mutation-type';
import cloneDeep from 'lodash/cloneDeep';
import * as devisConf from '@/configuration/devisConf';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import formatDate from '@/services/general/formatIsoDate';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

function initialState() {
  return {
    transmissions: [],
    totalTransmissions: 0,
    lastPayload: {},
    transmission: null,
    criteresRecherche: genererCritereRecherche('TRANSMISSION'),
  };
}

function gestionDataLoadTransmissions(critere, rootState, payload) {
  const data = cloneDeep(payload);
  data.query = cloneDeep(critere);
  data.query.societeId = rootState.societe.societeActiveId;
  if (data.query.dates) {
    data.query.dates.dateDebut = formatDate(data.query.dates.dateDebut);
    data.query.dates.dateFin = formatDate(data.query.dates.dateFin);
  }
  if (data.query.datesPremierAffichage) {
    data.query.datesPremierAffichage.dateDebut = formatDate(
      data.query.datesPremierAffichage.dateDebut,
    );
    data.query.datesPremierAffichage.dateFin = formatDate(
      data.query.datesPremierAffichage.dateFin,
    );
  }
  if (data.query.factorDateTransmission) {
    data.query.factorDateTransmission.dateDebut = formatDate(
      data.query.factorDateTransmission.dateDebut,
    );
    data.query.factorDateTransmission.dateFin = formatDate(
      data.query.factorDateTransmission.dateFin,
    );
  }
  if (data.query.groupeIds.length > 0) {
    data.query.groupeIds = data.query.groupeIds.map((groupe) => { return groupe.id; });
  }
  if (data.query.enseigneIds.length > 0) {
    data.query.enseigneIds = data.query.enseigneIds.map((enseigne) => { return enseigne.id; });
  }
  if (data.query.agencesId.length === 0) {
    data.query.agencesId = rootState.societe.agenceActive.map(agence => agence.agenceId);
  }
  if (data.query.clients.length > 0) {
    data.query.tiersId = data.query.clients.map((client) => client.id);
  }
  if (data.query.produitsIds.length > 0) {
    data.query.produitsIds = data.query.produitsIds.map(produit => produit.id);
  }
  if (data.query.commandeIds.length > 0) {
    data.query.commandeIds = data.query.commandeIds.map(el => el.id);
  }
  if (data.query.tiersFactorIds.length > 0) {
    data.query.tiersFactorIds = data.query.tiersFactorIds.map(factor => factor.id);
  }
  if (rootState.parametres.parametresInterne[PARAMETRES_INTERNE_KEYS.modulePresse.key]) {
    if (data.query.parutionsIds.length > 0) {
      data.query.parutionsIds = data.query.parutionsIds.map(el => el.id);
    }
    if (data.query.planMediaIds.length > 0) {
      data.query.planMediaIds = data.query.planMediaIds.map(el => el.id);
    }
    if (data.query.regleFacturationIds.length > 0) {
      data.query.regleFacturationIds = data.query.regleFacturationIds.map(el => el.id);
    }
  }
  delete data.query.clients;
  data.query.etat = tagInputToArray(critere.etat, 'code');
  data.query.categorieVente = tagInputToArray(critere.categorieVente, 'code');
  data.query.sousType = tagInputToArray(critere.type, 'code');
  data.query.type = devisConf.TYPE_FACTURE;
  return data;
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_FACTURES](state, transmissions) {
    state.transmissions = transmissions;
  },
  [types.SET_TOTAL_FACTURES](state, totalTransmissions) {
    state.totalTransmissions = totalTransmissions;
  },
  [types.SET_FACTURE_LAST_PAYLOAD](state, lastPayload) {
    state.lastPayload = lastPayload;
  },
  [types.SET_FACTURE](state, transmission) {
    state.transmission = transmission;
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [types.RESET_CRITERE](state) {
    state.criteresRecherche = initialState().criteresRecherche;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadTransmissions({ commit, getters, rootState }, payload) {
    const data = gestionDataLoadTransmissions(getters.criteresRecherche, rootState, payload);
    const result = (await getAll(data)).data.result;
    commit(types.SET_FACTURE_LAST_PAYLOAD, data);
    formatListeFactures(result.items);
    commit(types.SET_TOTAL_FACTURES, result.totalCount);
    commit(types.SET_FACTURES, result.items);
    return {
      data: result.items,
      count: result.totalCount,
    };
  },
};

const getters = {
  transmissions: state => {
    return state.transmissions;
  },
  totalTransmissions: state => {
    return state.totalTransmissions;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
  transmission: state => {
    return state.transmission;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
